<div class="container section__enrollmentLibrary h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="align__top">
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <div class="sales-phone-enrollment-library">
          <kredi-phone-enrollment-flow
            *ngIf="enrollmentContext"
            [enrollmentContext]="enrollmentContext"
            (completed)="onCompleted($event)">
          </kredi-phone-enrollment-flow>
        </div>
      </article>
    </div>
  </div>
</div>
